import { FranchiseActionTypes } from './constants';

const INIT_STATE = {
    franchises: [],
    currentFranchiseId: null,
    loading: false,
    error: null,
};

const Franchise = (state = INIT_STATE, action: any) => {
    switch (action.type) {
        case FranchiseActionTypes.GET_FRANCHISES:
            return { ...state, loading: true };
        case FranchiseActionTypes.GET_FRANCHISES_SUCCESS:
            return { ...state, franchises: action.payload, loading: false, error: null };
        case FranchiseActionTypes.GET_FRANCHISES_ERROR:
            return { ...state, error: action.payload, loading: false };
        case FranchiseActionTypes.SET_CURRENT_FRANCHISE:
            return { ...state, currentFranchiseId: action.payload };
        default:
            return state;
    }
};

export default Franchise;
